import pluginTypes from 'constants/pluginTypes';

const pickIdByType = (items, type) => {
  if (!items?.length || !type) {
    return '';
  }
  const normalizedType = String(type).toLowerCase();
  const hit = items.find((item) => {
    const itemType = (item.type || item.pluginType || '').toLowerCase();
    return itemType === normalizedType;
  });
  return hit?.elementId || '';
};

/**
 * Resolves course / lesson / unit ids from explicit values or expanded ancestry.
 * Sync only — no breadcrumb or manifest lookups.
 *
 * @param {Object} [params]
 * @param {string} [params.lessonId]
 * @param {string} [params.courseId]
 * @param {string} [params.chapterId] – unit/chapter id (GTM uses chapterId)
 * @param {string} [params.unitId] – alias for chapterId
 * @param {string} [params.workspaceId]
 * @param {string} [params.screenId]
 * @param {string} [params.sectionId] – screen section / element ref (GTM uses section_id)
 * @param {Array<{ elementId: string, type?: string, pluginType?: string }>} [params.expandedAncestry]
 * @returns {{ lessonId: string, courseId: string, chapterId: string, workspaceId: string, screenId: string, sectionId: string }}
 */
export default function resolveCoursewareIds({
  lessonId = '',
  courseId = '',
  chapterId = '',
  unitId = '',
  workspaceId = '',
  screenId = '',
  sectionId = '',
  expandedAncestry = [],
} = {}) {
  const fromAncestry = expandedAncestry.length
    ? {
      courseId: pickIdByType(expandedAncestry, pluginTypes.COURSE),
      lessonId: pickIdByType(expandedAncestry, pluginTypes.LESSON),
      unitId: pickIdByType(expandedAncestry, pluginTypes.UNIT)
        || pickIdByType(expandedAncestry, 'chapter'),
    }
    : {};

  return {
    lessonId: lessonId || fromAncestry.lessonId || '',
    courseId: courseId || fromAncestry.courseId || '',
    chapterId: chapterId || unitId || fromAncestry.unitId || '',
    workspaceId: workspaceId || '',
    screenId: screenId || '',
    sectionId: sectionId || '',
  };
}
